import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-workflow-config-details-skeleton',
    templateUrl: './workflow-config-details-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowConfigDetailsSkeletonComponent {}
